import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';

@Component({
    selector: 'app-archive-candidate-modal',
    templateUrl: './archive-candidate-modal.component.html',
    styleUrls: ['./archive-candidate-modal.component.scss'],
    standalone: false
})
export class ArchiveCandidateModalComponent implements OnInit {

  archivedReasons: any[] = [];
  archivereason: UntypedFormControl = new UntypedFormControl(null, Validators.required);
  description: UntypedFormControl = new UntypedFormControl(null);
  @Input() data: any;
  @Input() projectNumber: string;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() notifyParent = new EventEmitter<string>();
  @Input() archivetype: string;
  @Input() calledFrom: string;

  constructor(private modelService: NgbModal, private aiSourcingService: AiSourcingService, private aiSourcingHandlerService: AiSourcingHandlerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.projectNumber = window.location.pathname?.split('/')[4];

    this.getArchivedReasons();
  }

  dismiss() {
    this.modelService.dismissAll();
    this.notifyParent.emit('closemodal')
  }

  getArchivedReasons() {
    this.aiSourcingService.getArchivedReasons().subscribe((response: any) => {
      if (response && response.data) {
        this.archivedReasons = response.data;
      } else {
        console.error('No data found in the response');
      }
    });
  }

  archiveCandidate() {
    if(this.archivereason.valid) {
      let candidateIds = [];
      if(this.archivetype === "Bulk") {
        this.data.forEach(candidate => {
          candidateIds.push(candidate.id);
        });
      } else {
        candidateIds.push(this.data.id);
      }
      const payload = {
        projectnumber: this.projectNumber,
        status: "archive",
        elasticids: candidateIds,

        archivedreasons: {
          archivereasonids: [Number(this.archivereason.value)],
          description: this.description.value
        }
      };
      this.aiSourcingService.changeCandidateStatus(payload).subscribe((response: any) => {
        if (response && response.status === 'success') {
          this.modelService.dismissAll();
          this.passEntry.emit("success");
          this.notifyParent.emit('success')
        } else {
          this.passEntry.emit("error");
          this.notifyParent.emit('error')
          console.error('No data found in the response');
        }
      }, (err)=>{
        if(err.status === 422){
            this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
            this.router.navigate([`/ai-sourcing/project-list`]);
        }
      })
    }
  }
}




